import type {FC, PropsWithChildren} from 'react';

import {DocumentListSelection} from '@/modules/page/components/content-blocks/document-list-selection';

import type {DocumentListSelectionFragmentType} from './query';

type Props = PropsWithChildren & {
	data: DocumentListSelectionFragmentType;
};

export const DocumentListSelectionContainer: FC<Props> = ({data}) => {
	return (
		<DocumentListSelection
			spacingBottom={data.layout?.spacingBottom}
			spacingTop={data.layout?.spacingTop}
			heading={data.heading}
			documents={data.documentationFiles}
		/>
	);
};
